import { SET_INITIAL_PACKAGE } from '../actions/setInitialPackage'

const initialPackage = (state = null, action) => {
  return action.type === SET_INITIAL_PACKAGE ? action.payload : state
}

export default initialPackage

export const getInitialPackageData = state => {
  const identifier = state.initialPackage
  return state.availablePackages && state.availablePackages[identifier]
    ? state.availablePackages[identifier]
    : null
}
